import {
  CROWDING_EXTRACTION_VALUES,
  DENTITION_TYPE
} from 'constants/prescriptionOptions';
import { TreatmentPLanPreferenceFormType } from 'types/Settings.types';
import { TpvApiInput, TPVFormTypes } from 'types/TPVForm.types';
import { UltraTreatmentSpecType } from 'types/UltraPrescription.types';
import { ZenClearUltraApiInput } from 'types/ZenClearUltraApiInput.types';

import { buildUltraTpvPayload } from './ultraPrescription.payload.utils';
import { isDentitionTypeSelected } from './ultraPrescription.shared';
import { formatTeeth } from './ultraPrescription.teeth.utils';

export {
  convertToOptionsType,
  getStringValue,
  getSubOptionFromList,
  isDentitionTypeSelected,
  isOptionSelected,
  isOtherOptionSelected
} from './ultraPrescription.shared';
export {
  formatTeeth,
  formatTeethsForController,
  getToothChartValues,
  isFormattedTeethString,
  isPrimaryTeethString,
  splitTeethByDentition,
  splitTeethOrTextField
} from './ultraPrescription.teeth.utils';
export {
  getSagittalRelationshipData,
  getSagittalTreatmentOptions
} from './ultraPrescription.sagittal.utils';
export {
  getCrowdingSubOptions,
  mapAuxiliariesAndAppliancesForApi,
  mapUltraAuxiliaryInfoForRejection
} from './ultraPrescription.payload.utils';
export {
  formatUltraForForm,
  getDefaultZenClearUltraTreatmentSpec
} from './ultraPrescription.form.utils';

export const getZenClearUltraDataForTreatmentSpec = (
  isTreatmentTypeChanged: boolean,
  ClinicalPreferencesData: TreatmentPLanPreferenceFormType,
  data?: UltraTreatmentSpecType
): TpvApiInput => {
  const others = ClinicalPreferencesData?.ZenClearUltra?.others;
  const ultraPayload: ZenClearUltraApiInput = {
    ...buildUltraTpvPayload({ treatmentSpecifications: data }),
    specialNotes: data?.specialNotes,
    translatedSpecialNotes: data?.translatedSpecialNotes,
    type: TPVFormTypes.ZENCLEAR_ULTRA,
    clinicalPreferences: isTreatmentTypeChanged ? {} : others ? { others } : {},
    ...(data?.extraction?.Extraction ===
      CROWDING_EXTRACTION_VALUES.EXTRACTION &&
    isDentitionTypeSelected(
      data?.extraction?.dentitionSelection,
      DENTITION_TYPE.ADULT_DENTITION
    )
      ? {
          teethToExtract: formatTeeth(data?.extraction?.toothChart)
        }
      : {})
  };
  return ultraPayload;
};
